import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BrutalistButton from '../BrutalistButton';
import ConfirmAbandonModal from './ConfirmAbandonModal';
import styles from '../../styles/test/TestStyles.module.css';
import { vibrate } from '../../utils/appModeUtils';

const TestControls = ({
  onSaltar,
  onFinalizar,
  isLastQuestion
}) => {
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const navigate = useNavigate();

  // Calculate if we have three buttons
  const hasThreeButtons = isLastQuestion;

  const handleConfirmAbandon = () => {
    vibrate([50, 50, 50]); // Pattern vibration for abandon
    navigate('/');
  };
  
  const handleAbandonClick = () => {
    vibrate(50); // Short vibration for button press
    setShowConfirmModal(true);
  };
  
  const handleSkipClick = () => {
    vibrate(50); // Short vibration for button press
    onSaltar();
  };
  
  const handleFinishClick = () => {
    vibrate([100, 50, 100]); // Pattern vibration for completion
    onFinalizar();
  };

  return (
    <>
      <div className={styles.actionButtons}>
        <div className={`${styles.actionButtonsInner} ${hasThreeButtons ? styles.hasThreeButtons : ''}`}>
          <BrutalistButton
            variant="primary"
            onClick={handleAbandonClick}
            aria-label="Abandonar el test actual"
            className={styles.abandonButton}
          >
            Abandonar
          </BrutalistButton>

          <BrutalistButton
            variant="secondary"
            onClick={handleSkipClick}
            aria-label="Saltar a la siguiente pregunta sin contestar (0 puntos)"
          >
            No contestar
          </BrutalistButton>

          {isLastQuestion && (
            <BrutalistButton
              variant="primary"
              onClick={handleFinishClick}
              aria-label="Finalizar el test y ver resultados"
              className={styles.finishButton}
            >
              Finalizar
            </BrutalistButton>
          )}
        </div>
      </div>

      <ConfirmAbandonModal
        isOpen={showConfirmModal}
        onClose={() => setShowConfirmModal(false)}
        onConfirm={handleConfirmAbandon}
      />
    </>
  );
};

export default TestControls;